import { Injectable } from '@angular/core';
import {DashboardAdapter} from "./dashboard.adapter";
import {DashboardRequestConfig, DashboardStatusRequest} from "./dashboard.model";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(private dashboardAdapter: DashboardAdapter) { }

  getRecentBuyItems(dashboardRequestConfig: DashboardRequestConfig): Observable<DashboardStatusRequest> {
    return this.dashboardAdapter.getRecentBuyItems(dashboardRequestConfig);
  }
}
